import { BUILT_IN_COMPONENT_IDS, BUILT_IN_COMPONENT_SCHEMA_ID_BY_COMPONENT, componentSchemas, } from '@smoothie-framework/ui-core/schemas';
import { ACCORDION_EMPTY_RECIPE_VARIANTS, TABS_RECIPE_VARIANTS, ACCORDION_RECIPE_VARIANTS, ALERT_RECIPE_VARIANTS, BUTTON_GROUP_RECIPE_VARIANTS, BUTTON_RECIPE_VARIANTS, BREADCRUMB_RECIPE_VARIANTS, CHECKBOX_GROUP_RECIPE_VARIANTS, CHECKBOX_RECIPE_VARIANTS, CHART_RECIPE_VARIANTS, COMPOSER_RECIPE_VARIANTS, MESSAGE_PAIR_RECIPE_VARIANTS, TOOL_CALL_RECIPE_VARIANTS, CODE_BLOCK_RECIPE_VARIANTS, CODE_RECIPE_VARIANTS, DIVIDER_RECIPE_VARIANTS, DROPDOWN_MENU_CONTENT_RECIPE_VARIANTS, DROPDOWN_MENU_ITEM_RECIPE_VARIANTS, DROPDOWN_MENU_LABEL_RECIPE_VARIANTS, DROPDOWN_MENU_RECIPE_VARIANTS, DROPDOWN_MENU_TRIGGER_RECIPE_VARIANTS, EMPTY_RECIPE_VARIANTS, FIELD_ERROR_RECIPE_VARIANTS, FIELD_GROUP_RECIPE_VARIANTS, FIELD_LABEL_RECIPE_VARIANTS, FIELD_RECIPE_VARIANTS, FIELD_SET_RECIPE_VARIANTS, FLYOUT_ITEM_RECIPE_VARIANTS, FLYOUT_RECIPE_VARIANTS, INPUT_RECIPE_VARIANTS, LABEL_RECIPE_VARIANTS, LINK_RECIPE_VARIANTS, MODAL_CONTENT_RECIPE_VARIANTS, MODAL_POSITIONER_RECIPE_VARIANTS, NAV_TREE_RECIPE_VARIANTS, PROGRESS_RECIPE_VARIANTS, RADIO_GROUP_RECIPE_VARIANTS, RADIO_RECIPE_VARIANTS, SCROLL_AREA_RECIPE_VARIANTS, SEGMENTED_CONTROL_RECIPE_VARIANTS, SELECT_RECIPE_VARIANTS, SPINNER_RECIPE_VARIANTS, STACK_RECIPE_VARIANTS, STREAMING_TEXT_RECIPE_VARIANTS, SWITCH_RECIPE_VARIANTS, TABLE_CAPTION_RECIPE_VARIANTS, TABLE_EMPTY_RECIPE_VARIANTS, TABLE_RECIPE_VARIANTS, TABLE_SCROLL_AREA_RECIPE_VARIANTS, TEXT_RECIPE_VARIANTS, TEXTAREA_RECIPE_VARIANTS, TOAST_RECIPE_VARIANTS, TOASTER_RECIPE_VARIANTS, } from './built-in-component-projection';
function compareStrings(left, right) {
    if (left < right) {
        return -1;
    }
    if (left > right) {
        return 1;
    }
    return 0;
}
function freezeGuardrails(input) {
    if (!input) {
        return Object.freeze({});
    }
    return Object.freeze(Object.fromEntries(Object.entries(input).map(([propName, guardrail]) => [
        propName,
        Object.freeze({
            ...(guardrail.scanner && {
                scanner: Object.freeze({
                    ...guardrail.scanner,
                    ...(guardrail.scanner.variantProjection && {
                        variantProjection: Object.freeze({
                            component: guardrail.scanner.variantProjection.component,
                            axis: guardrail.scanner.variantProjection.axis,
                            valuesByInput: Object.freeze({
                                ...guardrail.scanner.variantProjection.valuesByInput,
                            }),
                        }),
                    }),
                }),
            }),
        }),
    ])));
}
function driverForSupport(support) {
    switch (support) {
        case 'recipe-backed':
            return 'recipe';
        case 'utility-only':
            return 'utility';
        default:
            return 'none';
    }
}
export const BUILT_IN_COMPONENT_VARIANTS = Object.freeze({
    Alert: ALERT_RECIPE_VARIANTS,
    Tabs: TABS_RECIPE_VARIANTS,
    TabsList: EMPTY_RECIPE_VARIANTS,
    TabsTrigger: EMPTY_RECIPE_VARIANTS,
    TabsContent: EMPTY_RECIPE_VARIANTS,
    Accordion: ACCORDION_RECIPE_VARIANTS,
    AccordionItem: ACCORDION_EMPTY_RECIPE_VARIANTS,
    AccordionTrigger: ACCORDION_EMPTY_RECIPE_VARIANTS,
    AccordionIndicator: ACCORDION_EMPTY_RECIPE_VARIANTS,
    AccordionContent: ACCORDION_EMPTY_RECIPE_VARIANTS,
    AccordionBody: ACCORDION_EMPTY_RECIPE_VARIANTS,
    Box: EMPTY_RECIPE_VARIANTS,
    Button: BUTTON_RECIPE_VARIANTS,
    ButtonGroup: BUTTON_GROUP_RECIPE_VARIANTS,
    Breadcrumb: BREADCRUMB_RECIPE_VARIANTS,
    BreadcrumbList: EMPTY_RECIPE_VARIANTS,
    BreadcrumbItem: EMPTY_RECIPE_VARIANTS,
    BreadcrumbLink: EMPTY_RECIPE_VARIANTS,
    BreadcrumbCurrentLink: EMPTY_RECIPE_VARIANTS,
    BreadcrumbSeparator: EMPTY_RECIPE_VARIANTS,
    BreadcrumbEllipsis: EMPTY_RECIPE_VARIANTS,
    Checkbox: CHECKBOX_RECIPE_VARIANTS,
    Chart: CHART_RECIPE_VARIANTS,
    Composer: COMPOSER_RECIPE_VARIANTS,
    MessagePair: MESSAGE_PAIR_RECIPE_VARIANTS,
    ToolCall: TOOL_CALL_RECIPE_VARIANTS,
    StreamingText: STREAMING_TEXT_RECIPE_VARIANTS,
    CheckboxGroup: CHECKBOX_GROUP_RECIPE_VARIANTS,
    Code: CODE_RECIPE_VARIANTS,
    CodeBlock: CODE_BLOCK_RECIPE_VARIANTS,
    Divider: DIVIDER_RECIPE_VARIANTS,
    DropdownMenu: DROPDOWN_MENU_RECIPE_VARIANTS,
    DropdownMenuTrigger: DROPDOWN_MENU_TRIGGER_RECIPE_VARIANTS,
    DropdownMenuContextTrigger: DROPDOWN_MENU_TRIGGER_RECIPE_VARIANTS,
    DropdownMenuContent: DROPDOWN_MENU_CONTENT_RECIPE_VARIANTS,
    DropdownMenuItem: DROPDOWN_MENU_ITEM_RECIPE_VARIANTS,
    DropdownMenuCheckboxItem: DROPDOWN_MENU_ITEM_RECIPE_VARIANTS,
    DropdownMenuRadioGroup: EMPTY_RECIPE_VARIANTS,
    DropdownMenuRadioItem: DROPDOWN_MENU_ITEM_RECIPE_VARIANTS,
    DropdownMenuGroup: EMPTY_RECIPE_VARIANTS,
    DropdownMenuLabel: DROPDOWN_MENU_LABEL_RECIPE_VARIANTS,
    DropdownMenuSeparator: EMPTY_RECIPE_VARIANTS,
    DropdownMenuShortcut: EMPTY_RECIPE_VARIANTS,
    DropdownMenuSub: EMPTY_RECIPE_VARIANTS,
    DropdownMenuSubTrigger: DROPDOWN_MENU_ITEM_RECIPE_VARIANTS,
    DropdownMenuSubContent: DROPDOWN_MENU_CONTENT_RECIPE_VARIANTS,
    Field: FIELD_RECIPE_VARIANTS,
    FieldDescription: EMPTY_RECIPE_VARIANTS,
    FieldError: FIELD_ERROR_RECIPE_VARIANTS,
    FieldGroup: FIELD_GROUP_RECIPE_VARIANTS,
    FieldLabel: FIELD_LABEL_RECIPE_VARIANTS,
    FieldLegend: FIELD_LABEL_RECIPE_VARIANTS,
    FieldSet: FIELD_SET_RECIPE_VARIANTS,
    Flyout: FLYOUT_RECIPE_VARIANTS,
    FlyoutItem: FLYOUT_ITEM_RECIPE_VARIANTS,
    Modal: EMPTY_RECIPE_VARIANTS,
    ModalTrigger: EMPTY_RECIPE_VARIANTS,
    ModalBackdrop: EMPTY_RECIPE_VARIANTS,
    ModalPositioner: MODAL_POSITIONER_RECIPE_VARIANTS,
    ModalContent: MODAL_CONTENT_RECIPE_VARIANTS,
    ModalHeader: EMPTY_RECIPE_VARIANTS,
    ModalTitle: EMPTY_RECIPE_VARIANTS,
    ModalDescription: EMPTY_RECIPE_VARIANTS,
    ModalBody: EMPTY_RECIPE_VARIANTS,
    ModalFooter: EMPTY_RECIPE_VARIANTS,
    ModalCloseTrigger: EMPTY_RECIPE_VARIANTS,
    ModalActionTrigger: EMPTY_RECIPE_VARIANTS,
    Table: TABLE_RECIPE_VARIANTS,
    TableScrollArea: TABLE_SCROLL_AREA_RECIPE_VARIANTS,
    TableCaption: TABLE_CAPTION_RECIPE_VARIANTS,
    TableColumnGroup: TABLE_EMPTY_RECIPE_VARIANTS,
    TableColumn: TABLE_EMPTY_RECIPE_VARIANTS,
    TableHeader: TABLE_EMPTY_RECIPE_VARIANTS,
    TableBody: TABLE_EMPTY_RECIPE_VARIANTS,
    TableFooter: TABLE_EMPTY_RECIPE_VARIANTS,
    TableRow: TABLE_EMPTY_RECIPE_VARIANTS,
    TableColumnHeader: TABLE_EMPTY_RECIPE_VARIANTS,
    TableCell: TABLE_EMPTY_RECIPE_VARIANTS,
    Flex: EMPTY_RECIPE_VARIANTS,
    Grid: EMPTY_RECIPE_VARIANTS,
    GridItem: EMPTY_RECIPE_VARIANTS,
    Heading: TEXT_RECIPE_VARIANTS,
    Label: LABEL_RECIPE_VARIANTS,
    InputCharacterCount: EMPTY_RECIPE_VARIANTS,
    Link: LINK_RECIPE_VARIANTS,
    Progress: PROGRESS_RECIPE_VARIANTS,
    Radio: RADIO_RECIPE_VARIANTS,
    RadioGroup: RADIO_GROUP_RECIPE_VARIANTS,
    ScrollArea: SCROLL_AREA_RECIPE_VARIANTS,
    Select: SELECT_RECIPE_VARIANTS,
    SegmentedControl: SEGMENTED_CONTROL_RECIPE_VARIANTS,
    NavTree: NAV_TREE_RECIPE_VARIANTS,
    NavTreeItem: EMPTY_RECIPE_VARIANTS,
    NavTreeSection: EMPTY_RECIPE_VARIANTS,
    Spacer: EMPTY_RECIPE_VARIANTS,
    Spinner: SPINNER_RECIPE_VARIANTS,
    Toast: TOAST_RECIPE_VARIANTS,
    Toaster: TOASTER_RECIPE_VARIANTS,
    Stack: STACK_RECIPE_VARIANTS,
    StackCol: STACK_RECIPE_VARIANTS,
    StackRow: STACK_RECIPE_VARIANTS,
    Switch: SWITCH_RECIPE_VARIANTS,
    Text: TEXT_RECIPE_VARIANTS,
    TextInput: INPUT_RECIPE_VARIANTS,
    Textarea: TEXTAREA_RECIPE_VARIANTS,
});
/**
 * Public compound parts that materialize the owning component's styled
 * runtime structure. The scanner records these under the owner so a JIT
 * manifest remains independent of whether an app uses shorthand or parts.
 */
export const BUILT_IN_COMPONENT_STYLE_ALIASES = Object.freeze({
    ComposerRoot: 'Composer',
    ComposerInput: 'Composer',
    ComposerFooter: 'Composer',
    ComposerActionGroup: 'Composer',
    ComposerAttachmentTrigger: 'Composer',
    ComposerSubmit: 'Composer',
    ComposerCancel: 'Composer',
    MessagePairRoot: 'MessagePair',
    MessagePairUser: 'MessagePair',
    MessagePairAssistant: 'MessagePair',
    MessagePairActions: 'MessagePair',
    ToolCallRoot: 'ToolCall',
    ToolCallTrigger: 'ToolCall',
    ToolCallSummary: 'ToolCall',
    ToolCallStatus: 'ToolCall',
    ToolCallDetails: 'ToolCall',
    ToolCallRequest: 'ToolCall',
    ToolCallResult: 'ToolCall',
});
export const BUILT_IN_COMPONENT_RECIPE_NAME_BY_COMPONENT = Object.freeze({
    Alert: 'alert',
    Tabs: 'tabs',
    TabsList: 'tabs-list',
    TabsTrigger: 'tabs-trigger',
    TabsContent: 'tabs-content',
    Accordion: 'accordion',
    AccordionItem: 'accordion-item',
    AccordionTrigger: 'accordion-trigger',
    AccordionIndicator: 'accordion-indicator',
    AccordionContent: 'accordion-content',
    AccordionBody: 'accordion-body',
    Box: 'box',
    Button: 'button',
    ButtonGroup: 'button-group',
    Breadcrumb: 'breadcrumb',
    BreadcrumbList: 'breadcrumb-list',
    BreadcrumbItem: 'breadcrumb-item',
    BreadcrumbLink: 'breadcrumb-link',
    BreadcrumbCurrentLink: 'breadcrumb-current-link',
    BreadcrumbSeparator: 'breadcrumb-separator',
    BreadcrumbEllipsis: 'breadcrumb-ellipsis',
    Checkbox: 'checkbox',
    Chart: 'chart',
    Composer: 'composer',
    MessagePair: 'message-pair',
    ToolCall: 'tool-call',
    StreamingText: 'streaming-text',
    CheckboxGroup: 'checkbox-group',
    Code: 'code',
    CodeBlock: 'code-block',
    Divider: 'divider',
    DropdownMenu: 'dropdown-menu',
    DropdownMenuTrigger: 'dropdown-menu-trigger',
    DropdownMenuContextTrigger: 'dropdown-menu-trigger',
    DropdownMenuContent: 'dropdown-menu-content',
    DropdownMenuItem: 'dropdown-menu-item',
    DropdownMenuCheckboxItem: 'dropdown-menu-item',
    DropdownMenuRadioGroup: 'dropdown-menu-group',
    DropdownMenuRadioItem: 'dropdown-menu-item',
    DropdownMenuGroup: 'dropdown-menu-group',
    DropdownMenuLabel: 'dropdown-menu-label',
    DropdownMenuSeparator: 'dropdown-menu-separator',
    DropdownMenuShortcut: 'dropdown-menu-shortcut',
    DropdownMenuSub: 'dropdown-menu-sub',
    DropdownMenuSubTrigger: 'dropdown-menu-item',
    DropdownMenuSubContent: 'dropdown-menu-content',
    Field: 'field',
    FieldDescription: 'field-description',
    FieldError: 'field-error',
    FieldGroup: 'field-group',
    FieldLabel: 'field-label',
    FieldLegend: 'field-legend',
    FieldSet: 'field-set',
    Flyout: 'flyout',
    FlyoutItem: 'flyout-item',
    Modal: 'modal',
    ModalTrigger: 'modal-trigger',
    ModalBackdrop: 'modal-backdrop',
    ModalPositioner: 'modal-positioner',
    ModalContent: 'modal-content',
    ModalHeader: 'modal-header',
    ModalTitle: 'modal-title',
    ModalDescription: 'modal-description',
    ModalBody: 'modal-body',
    ModalFooter: 'modal-footer',
    ModalCloseTrigger: 'modal-close-trigger',
    ModalActionTrigger: 'modal-action-trigger',
    Table: 'table',
    TableScrollArea: 'table-scroll-area',
    TableCaption: 'table-caption',
    TableColumnGroup: 'table-column-group',
    TableColumn: 'table-column',
    TableHeader: 'table-header',
    TableBody: 'table-body',
    TableFooter: 'table-footer',
    TableRow: 'table-row',
    TableColumnHeader: 'table-column-header',
    TableCell: 'table-cell',
    Flex: 'flex',
    Grid: 'grid',
    GridItem: 'grid-item',
    Heading: 'heading',
    Label: 'label',
    InputCharacterCount: 'input-character-count',
    Link: 'link',
    Progress: 'progress',
    Radio: 'radio',
    RadioGroup: 'radio-group',
    ScrollArea: 'scroll-area',
    Select: 'select',
    SegmentedControl: 'segmented-control',
    NavTree: 'nav-tree',
    NavTreeItem: 'nav-tree-item',
    NavTreeSection: 'nav-tree-section',
    Spacer: 'spacer',
    Spinner: 'spinner',
    Toast: 'toast',
    Toaster: 'toaster',
    Stack: 'stack',
    StackCol: 'stack-col',
    StackRow: 'stack-row',
    Switch: 'switch',
    Text: 'text',
    TextInput: 'input',
    Textarea: 'textarea',
});
export const BUILT_IN_RECIPE_VARIANTS_BY_RECIPE_NAME = Object.freeze(Object.fromEntries(BUILT_IN_COMPONENT_IDS.map((componentId) => [
    BUILT_IN_COMPONENT_RECIPE_NAME_BY_COMPONENT[componentId],
    BUILT_IN_COMPONENT_VARIANTS[componentId],
])));
export const COMPONENT_STYLING_SUPPORT_BY_COMPONENT = Object.freeze({
    Alert: 'recipe-backed',
    Tabs: 'recipe-backed',
    TabsList: 'recipe-backed',
    TabsTrigger: 'recipe-backed',
    TabsContent: 'recipe-backed',
    Accordion: 'recipe-backed',
    AccordionItem: 'recipe-backed',
    AccordionTrigger: 'recipe-backed',
    AccordionIndicator: 'recipe-backed',
    AccordionContent: 'recipe-backed',
    AccordionBody: 'recipe-backed',
    Box: 'utility-only',
    Button: 'recipe-backed',
    ButtonGroup: 'recipe-backed',
    Breadcrumb: 'recipe-backed',
    BreadcrumbList: 'recipe-backed',
    BreadcrumbItem: 'recipe-backed',
    BreadcrumbLink: 'recipe-backed',
    BreadcrumbCurrentLink: 'recipe-backed',
    BreadcrumbSeparator: 'recipe-backed',
    BreadcrumbEllipsis: 'recipe-backed',
    Checkbox: 'recipe-backed',
    Chart: 'recipe-backed',
    Composer: 'recipe-backed',
    MessagePair: 'recipe-backed',
    ToolCall: 'recipe-backed',
    StreamingText: 'recipe-backed',
    CheckboxGroup: 'recipe-backed',
    Code: 'recipe-backed',
    CodeBlock: 'recipe-backed',
    Divider: 'recipe-backed',
    DropdownMenu: 'recipe-backed',
    DropdownMenuTrigger: 'recipe-backed',
    DropdownMenuContextTrigger: 'recipe-backed',
    DropdownMenuContent: 'recipe-backed',
    DropdownMenuItem: 'recipe-backed',
    DropdownMenuCheckboxItem: 'recipe-backed',
    DropdownMenuRadioGroup: 'recipe-backed',
    DropdownMenuRadioItem: 'recipe-backed',
    DropdownMenuGroup: 'recipe-backed',
    DropdownMenuLabel: 'recipe-backed',
    DropdownMenuSeparator: 'recipe-backed',
    DropdownMenuShortcut: 'recipe-backed',
    DropdownMenuSub: 'recipe-backed',
    DropdownMenuSubTrigger: 'recipe-backed',
    DropdownMenuSubContent: 'recipe-backed',
    Field: 'recipe-backed',
    FieldDescription: 'recipe-backed',
    FieldError: 'recipe-backed',
    FieldGroup: 'recipe-backed',
    FieldLabel: 'recipe-backed',
    FieldLegend: 'recipe-backed',
    FieldSet: 'recipe-backed',
    Flyout: 'recipe-backed',
    FlyoutItem: 'recipe-backed',
    Modal: 'recipe-backed',
    ModalTrigger: 'recipe-backed',
    ModalBackdrop: 'recipe-backed',
    ModalPositioner: 'recipe-backed',
    ModalContent: 'recipe-backed',
    ModalHeader: 'recipe-backed',
    ModalTitle: 'recipe-backed',
    ModalDescription: 'recipe-backed',
    ModalBody: 'recipe-backed',
    ModalFooter: 'recipe-backed',
    ModalCloseTrigger: 'recipe-backed',
    ModalActionTrigger: 'recipe-backed',
    Table: 'recipe-backed',
    TableScrollArea: 'recipe-backed',
    TableCaption: 'recipe-backed',
    TableColumnGroup: 'recipe-backed',
    TableColumn: 'recipe-backed',
    TableHeader: 'recipe-backed',
    TableBody: 'recipe-backed',
    TableFooter: 'recipe-backed',
    TableRow: 'recipe-backed',
    TableColumnHeader: 'recipe-backed',
    TableCell: 'recipe-backed',
    Flex: 'utility-only',
    Grid: 'utility-only',
    GridItem: 'utility-only',
    Heading: 'recipe-backed',
    InputCharacterCount: 'recipe-backed',
    Label: 'recipe-backed',
    Link: 'recipe-backed',
    Progress: 'recipe-backed',
    Radio: 'recipe-backed',
    RadioGroup: 'recipe-backed',
    ScrollArea: 'recipe-backed',
    Select: 'recipe-backed',
    SegmentedControl: 'recipe-backed',
    NavTree: 'recipe-backed',
    NavTreeItem: 'utility-only',
    NavTreeSection: 'utility-only',
    Spacer: 'utility-only',
    Spinner: 'recipe-backed',
    Toast: 'recipe-backed',
    Toaster: 'recipe-backed',
    Stack: 'utility-only',
    StackCol: 'utility-only',
    StackRow: 'utility-only',
    Switch: 'recipe-backed',
    Text: 'recipe-backed',
    TextInput: 'recipe-backed',
    Textarea: 'recipe-backed',
});
export const COMPONENT_STYLING_DRIVER_BY_COMPONENT = Object.freeze(Object.fromEntries(BUILT_IN_COMPONENT_IDS.map((componentId) => [
    componentId,
    driverForSupport(COMPONENT_STYLING_SUPPORT_BY_COMPONENT[componentId]),
])));
const VISIBILITY_PROP_GUARDRAILS = {
    hideFrom: {
        scanner: {
            responsiveSupport: 'unsupported',
        },
    },
    hideBelow: {
        scanner: {
            responsiveSupport: 'unsupported',
        },
    },
};
const RAW_BUILT_IN_COMPONENT_PROP_GUARDRAILS = {
    Alert: {},
    Chart: {},
    Box: {
        ...VISIBILITY_PROP_GUARDRAILS,
    },
    Breadcrumb: {},
    BreadcrumbCurrentLink: {},
    BreadcrumbEllipsis: {},
    BreadcrumbItem: {},
    BreadcrumbLink: {},
    BreadcrumbList: {},
    BreadcrumbSeparator: {},
    Button: {
        ...VISIBILITY_PROP_GUARDRAILS,
        disabled: { scanner: { responsiveSupport: 'unsupported' } },
        fullWidth: { scanner: { responsiveSupport: 'unsupported' } },
        icon: { scanner: { responsiveSupport: 'unsupported' } },
        loading: { scanner: { responsiveSupport: 'unsupported' } },
        spinnerPlacement: { scanner: { responsiveSupport: 'unsupported' } },
        spinnerSize: {
            scanner: {
                responsiveSupport: 'unsupported',
                variantProjection: {
                    component: 'Spinner',
                    axis: 'size',
                    valuesByInput: {
                        sm: 'sm',
                        md: 'md',
                        lg: 'lg',
                    },
                },
            },
        },
    },
    ButtonGroup: {
        attached: { scanner: { responsiveSupport: 'unsupported' } },
        orientation: { scanner: { responsiveSupport: 'unsupported' } },
        size: { scanner: { responsiveSupport: 'unsupported' } },
        variant: { scanner: { responsiveSupport: 'unsupported' } },
    },
    Checkbox: {
        disabled: { scanner: { responsiveSupport: 'unsupported' } },
    },
    Composer: {
        disabled: {
            scanner: {
                responsiveSupport: 'unsupported',
            },
        },
    },
    MessagePair: {
        userVariant: {
            scanner: {
                responsiveSupport: 'unsupported',
                variantProjection: {
                    axis: 'variant',
                    valuesByInput: {
                        bubble: 'bubble',
                        plain: 'plain',
                    },
                },
            },
        },
    },
    ToolCall: {
        state: {
            scanner: {
                responsiveSupport: 'unsupported',
            },
        },
        open: { scanner: { responsiveSupport: 'unsupported' } },
    },
    StreamingText: {
        segments: { scanner: { responsiveSupport: 'unsupported' } },
        revealedWordCount: { scanner: { responsiveSupport: 'unsupported' } },
        status: { scanner: { responsiveSupport: 'unsupported' } },
        showCaret: { scanner: { responsiveSupport: 'unsupported' } },
    },
    CheckboxGroup: {
        disabled: { scanner: { responsiveSupport: 'unsupported' } },
        orientation: { scanner: { responsiveSupport: 'unsupported' } },
    },
    Code: {
        color: { scanner: { detection: 'enum-or-extension-only' } },
    },
    CodeBlock: {
        background: { scanner: { responsiveSupport: 'unsupported' } },
        backgroundColor: { scanner: { responsiveSupport: 'unsupported' } },
        showLineNumbers: { scanner: { responsiveSupport: 'unsupported' } },
        highlightLines: { scanner: { responsiveSupport: 'unsupported' } },
        focusedLineNumbers: { scanner: { responsiveSupport: 'unsupported' } },
        addedLineNumbers: { scanner: { responsiveSupport: 'unsupported' } },
        removedLineNumbers: { scanner: { responsiveSupport: 'unsupported' } },
    },
    Divider: {
        ...VISIBILITY_PROP_GUARDRAILS,
    },
    DropdownMenu: {
        ...VISIBILITY_PROP_GUARDRAILS,
        open: { scanner: { responsiveSupport: 'unsupported' } },
    },
    DropdownMenuTrigger: {
        ...VISIBILITY_PROP_GUARDRAILS,
        disabled: { scanner: { responsiveSupport: 'unsupported' } },
    },
    DropdownMenuContextTrigger: {
        ...VISIBILITY_PROP_GUARDRAILS,
        disabled: { scanner: { responsiveSupport: 'unsupported' } },
    },
    DropdownMenuContent: {
        ...VISIBILITY_PROP_GUARDRAILS,
    },
    DropdownMenuItem: {
        ...VISIBILITY_PROP_GUARDRAILS,
        disabled: { scanner: { responsiveSupport: 'unsupported' } },
        destructive: { scanner: { responsiveSupport: 'unsupported' } },
    },
    DropdownMenuCheckboxItem: {
        ...VISIBILITY_PROP_GUARDRAILS,
        checked: { scanner: { responsiveSupport: 'unsupported' } },
        disabled: { scanner: { responsiveSupport: 'unsupported' } },
        destructive: { scanner: { responsiveSupport: 'unsupported' } },
    },
    DropdownMenuRadioGroup: {
        ...VISIBILITY_PROP_GUARDRAILS,
    },
    DropdownMenuRadioItem: {
        ...VISIBILITY_PROP_GUARDRAILS,
        disabled: { scanner: { responsiveSupport: 'unsupported' } },
        destructive: { scanner: { responsiveSupport: 'unsupported' } },
    },
    DropdownMenuGroup: {
        ...VISIBILITY_PROP_GUARDRAILS,
    },
    DropdownMenuLabel: {
        ...VISIBILITY_PROP_GUARDRAILS,
        inset: { scanner: { responsiveSupport: 'unsupported' } },
    },
    DropdownMenuSeparator: {
        ...VISIBILITY_PROP_GUARDRAILS,
    },
    DropdownMenuShortcut: {
        ...VISIBILITY_PROP_GUARDRAILS,
    },
    DropdownMenuSub: {
        ...VISIBILITY_PROP_GUARDRAILS,
        open: { scanner: { responsiveSupport: 'unsupported' } },
    },
    DropdownMenuSubTrigger: {
        ...VISIBILITY_PROP_GUARDRAILS,
        disabled: { scanner: { responsiveSupport: 'unsupported' } },
        destructive: { scanner: { responsiveSupport: 'unsupported' } },
    },
    DropdownMenuSubContent: {
        ...VISIBILITY_PROP_GUARDRAILS,
    },
    Field: {
        disabled: { scanner: { responsiveSupport: 'unsupported' } },
        invalid: { scanner: { responsiveSupport: 'unsupported' } },
        readOnly: { scanner: { responsiveSupport: 'unsupported' } },
    },
    FieldDescription: {},
    FieldError: {},
    FieldGroup: {
        orientation: { scanner: { responsiveSupport: 'unsupported' } },
    },
    FieldLabel: {},
    FieldLegend: {},
    FieldSet: {
        disabled: { scanner: { responsiveSupport: 'unsupported' } },
        invalid: { scanner: { responsiveSupport: 'unsupported' } },
        readOnly: { scanner: { responsiveSupport: 'unsupported' } },
    },
    Flyout: {
        ...VISIBILITY_PROP_GUARDRAILS,
    },
    FlyoutItem: {
        ...VISIBILITY_PROP_GUARDRAILS,
        disabled: { scanner: { responsiveSupport: 'unsupported' } },
        selected: { scanner: { responsiveSupport: 'unsupported' } },
    },
    Tabs: {
        ...VISIBILITY_PROP_GUARDRAILS,
        orientation: { scanner: { responsiveSupport: 'unsupported' } },
        activationMode: { scanner: { responsiveSupport: 'unsupported' } },
        loopFocus: { scanner: { responsiveSupport: 'unsupported' } },
        lazyMount: { scanner: { responsiveSupport: 'unsupported' } },
        unmountOnExit: { scanner: { responsiveSupport: 'unsupported' } },
    },
    TabsList: { ...VISIBILITY_PROP_GUARDRAILS, showSeparator: { scanner: { responsiveSupport: 'unsupported' } } },
    TabsTrigger: { ...VISIBILITY_PROP_GUARDRAILS, disabled: { scanner: { responsiveSupport: 'unsupported' } } },
    TabsContent: { ...VISIBILITY_PROP_GUARDRAILS },
    Accordion: {
        ...VISIBILITY_PROP_GUARDRAILS,
        collapsible: { scanner: { responsiveSupport: 'unsupported' } },
        disabled: { scanner: { responsiveSupport: 'unsupported' } },
        multiple: { scanner: { responsiveSupport: 'unsupported' } },
    },
    AccordionItem: {
        ...VISIBILITY_PROP_GUARDRAILS,
        disabled: { scanner: { responsiveSupport: 'unsupported' } },
    },
    AccordionTrigger: {
        ...VISIBILITY_PROP_GUARDRAILS,
    },
    AccordionIndicator: {
        ...VISIBILITY_PROP_GUARDRAILS,
    },
    AccordionContent: {
        ...VISIBILITY_PROP_GUARDRAILS,
    },
    AccordionBody: {
        ...VISIBILITY_PROP_GUARDRAILS,
    },
    Modal: {
        ...VISIBILITY_PROP_GUARDRAILS,
        open: { scanner: { responsiveSupport: 'unsupported' } },
    },
    ModalTrigger: {
        ...VISIBILITY_PROP_GUARDRAILS,
        disabled: { scanner: { responsiveSupport: 'unsupported' } },
    },
    ModalBackdrop: {
        ...VISIBILITY_PROP_GUARDRAILS,
    },
    ModalPositioner: {
        ...VISIBILITY_PROP_GUARDRAILS,
        placement: { scanner: { responsiveSupport: 'unsupported' } },
    },
    ModalContent: {
        ...VISIBILITY_PROP_GUARDRAILS,
        placement: { scanner: { responsiveSupport: 'unsupported' } },
        role: { scanner: { responsiveSupport: 'unsupported' } },
        scrollBehavior: { scanner: { responsiveSupport: 'unsupported' } },
        showCloseButton: { scanner: { responsiveSupport: 'unsupported' } },
        size: { scanner: { responsiveSupport: 'unsupported' } },
    },
    ModalHeader: {
        ...VISIBILITY_PROP_GUARDRAILS,
    },
    ModalTitle: {
        ...VISIBILITY_PROP_GUARDRAILS,
    },
    ModalDescription: {
        ...VISIBILITY_PROP_GUARDRAILS,
    },
    ModalBody: {
        ...VISIBILITY_PROP_GUARDRAILS,
    },
    ModalFooter: {
        ...VISIBILITY_PROP_GUARDRAILS,
    },
    ModalCloseTrigger: {
        ...VISIBILITY_PROP_GUARDRAILS,
    },
    ModalActionTrigger: {
        ...VISIBILITY_PROP_GUARDRAILS,
    },
    Table: {
        ...VISIBILITY_PROP_GUARDRAILS,
        interactive: { scanner: { responsiveSupport: 'unsupported' } },
        showColumnBorder: { scanner: { responsiveSupport: 'unsupported' } },
        stickyHeader: { scanner: { responsiveSupport: 'unsupported' } },
        striped: { scanner: { responsiveSupport: 'unsupported' } },
    },
    TableScrollArea: {
        ...VISIBILITY_PROP_GUARDRAILS,
    },
    TableCaption: {
        ...VISIBILITY_PROP_GUARDRAILS,
    },
    TableColumnGroup: {
        ...VISIBILITY_PROP_GUARDRAILS,
    },
    TableColumn: {
        ...VISIBILITY_PROP_GUARDRAILS,
    },
    TableHeader: {
        ...VISIBILITY_PROP_GUARDRAILS,
    },
    TableBody: {
        ...VISIBILITY_PROP_GUARDRAILS,
    },
    TableFooter: {
        ...VISIBILITY_PROP_GUARDRAILS,
    },
    TableRow: {
        ...VISIBILITY_PROP_GUARDRAILS,
    },
    TableColumnHeader: {
        ...VISIBILITY_PROP_GUARDRAILS,
        colSpan: {
            scanner: {
                responsiveSupport: 'unsupported',
            },
        },
        rowSpan: {
            scanner: {
                responsiveSupport: 'unsupported',
            },
        },
    },
    TableCell: {
        ...VISIBILITY_PROP_GUARDRAILS,
        colSpan: {
            scanner: {
                responsiveSupport: 'unsupported',
            },
        },
        rowSpan: {
            scanner: {
                responsiveSupport: 'unsupported',
            },
        },
    },
    Flex: {
        ...VISIBILITY_PROP_GUARDRAILS,
    },
    Grid: {
        ...VISIBILITY_PROP_GUARDRAILS,
    },
    GridItem: {
        ...VISIBILITY_PROP_GUARDRAILS,
    },
    Heading: {
        color: {
            scanner: {
                detection: 'enum-or-extension-only',
                responsiveSupport: 'unsupported',
            },
        },
        level: {
            scanner: {
                responsiveSupport: 'unsupported',
                variantProjection: {
                    axis: 'size',
                    valuesByInput: {
                        '1': '4xl',
                        '2': '3xl',
                        '3': '2xl',
                        '4': 'xl',
                        '5': 'lg',
                        '6': 'md',
                    },
                },
            },
        },
    },
    Label: {
        textStyle: {
            scanner: {
                responsiveSupport: 'supported',
            },
        },
    },
    InputCharacterCount: {},
    Link: {},
    Progress: {},
    Radio: {
        disabled: { scanner: { responsiveSupport: 'unsupported' } },
    },
    RadioGroup: {
        disabled: { scanner: { responsiveSupport: 'unsupported' } },
        orientation: { scanner: { responsiveSupport: 'unsupported' } },
    },
    ScrollArea: {
        ...VISIBILITY_PROP_GUARDRAILS,
    },
    Select: {
        disabled: { scanner: { responsiveSupport: 'unsupported' } },
        error: {
            scanner: {
                responsiveSupport: 'unsupported',
                variantProjection: {
                    axis: 'invalid',
                    valuesByInput: {
                        true: 'true',
                        false: 'false',
                    },
                },
            },
        },
        invalid: { scanner: { responsiveSupport: 'unsupported' } },
    },
    SegmentedControl: {
        invalid: { scanner: { responsiveSupport: 'unsupported' } },
        itemContent: { scanner: { responsiveSupport: 'unsupported' } },
        layout: { scanner: { responsiveSupport: 'unsupported' } },
        orientation: { scanner: { responsiveSupport: 'unsupported' } },
        variant: { scanner: { responsiveSupport: 'unsupported' } },
    },
    NavTree: {
        ...VISIBILITY_PROP_GUARDRAILS,
        groupSelection: { scanner: { responsiveSupport: 'unsupported' } },
        selectParents: { scanner: { responsiveSupport: 'unsupported' } },
        size: { scanner: { responsiveSupport: 'unsupported' } },
    },
    NavTreeItem: {
        disabled: { scanner: { responsiveSupport: 'unsupported' } },
        expanded: { scanner: { responsiveSupport: 'unsupported' } },
        level: { scanner: { responsiveSupport: 'unsupported' } },
        selected: { scanner: { responsiveSupport: 'unsupported' } },
        toggleLabel: { scanner: { responsiveSupport: 'unsupported' } },
    },
    NavTreeSection: {},
    Spacer: {},
    Spinner: {},
    Toast: {
        closable: { scanner: { responsiveSupport: 'unsupported' } },
        duration: { scanner: { responsiveSupport: 'unsupported' } },
        iconStyle: { scanner: { responsiveSupport: 'unsupported' } },
        status: { scanner: { responsiveSupport: 'unsupported' } },
    },
    Toaster: {
        duration: { scanner: { responsiveSupport: 'unsupported' } },
        max: { scanner: { responsiveSupport: 'unsupported' } },
        offset: { scanner: { responsiveSupport: 'unsupported' } },
        pauseOnPageIdle: { scanner: { responsiveSupport: 'unsupported' } },
        position: { scanner: { responsiveSupport: 'unsupported' } },
    },
    Stack: {
        ...VISIBILITY_PROP_GUARDRAILS,
    },
    StackCol: {
        ...VISIBILITY_PROP_GUARDRAILS,
    },
    StackRow: {
        ...VISIBILITY_PROP_GUARDRAILS,
    },
    Switch: {
        checked: { scanner: { responsiveSupport: 'unsupported' } },
        invalid: { scanner: { responsiveSupport: 'unsupported' } },
    },
    Text: {
        ...VISIBILITY_PROP_GUARDRAILS,
        color: {
            scanner: {
                detection: 'enum-or-extension-only',
                responsiveSupport: 'unsupported',
            },
        },
    },
    TextInput: {
        error: {
            scanner: {
                responsiveSupport: 'unsupported',
                variantProjection: {
                    axis: 'invalid',
                    valuesByInput: {
                        true: 'true',
                        false: 'false',
                    },
                },
            },
        },
        disabled: { scanner: { responsiveSupport: 'unsupported' } },
        invalid: { scanner: { responsiveSupport: 'unsupported' } },
    },
    Textarea: {
        disabled: { scanner: { responsiveSupport: 'unsupported' } },
        error: {
            scanner: {
                responsiveSupport: 'unsupported',
                variantProjection: {
                    axis: 'invalid',
                    valuesByInput: {
                        true: 'true',
                        false: 'false',
                    },
                },
            },
        },
        invalid: { scanner: { responsiveSupport: 'unsupported' } },
    },
};
export const BUILT_IN_COMPONENT_PROP_GUARDRAILS = Object.freeze(Object.fromEntries(BUILT_IN_COMPONENT_IDS.map((componentId) => [
    componentId,
    freezeGuardrails(RAW_BUILT_IN_COMPONENT_PROP_GUARDRAILS[componentId]),
])));
export const BUILT_IN_COMPONENT_RESPONSIVE_PROPS = Object.freeze(Object.fromEntries(BUILT_IN_COMPONENT_IDS.map((componentId) => {
    const schemaComponentId = BUILT_IN_COMPONENT_SCHEMA_ID_BY_COMPONENT[componentId];
    const schema = componentSchemas[schemaComponentId];
    return [
        componentId,
        Object.freeze(Object.entries(schema.props)
            .filter(([, propDefinition]) => propDefinition.responsive === true)
            .map(([propName]) => propName)
            .sort(compareStrings)),
    ];
})));
export const BUILT_IN_LAYOUT_DEFAULT_UTILITY_PROPS = Object.freeze({
    StackCol: Object.freeze({
        align: 'stretch',
        gap: 4,
        justify: 'start',
        wrap: false,
    }),
    Divider: Object.freeze({
        background: 'borderSubtle',
    }),
    Grid: Object.freeze({
        gap: 4,
    }),
    Spacer: Object.freeze({
        alignSelf: 'stretch',
        basis: 0,
        grow: 1,
        justifySelf: 'stretch',
        shrink: 1,
    }),
    StackRow: Object.freeze({
        align: 'center',
        gap: 4,
        justify: 'start',
        wrap: false,
    }),
    Stack: Object.freeze({
        align: 'stretch',
        direction: 'column',
        gap: 4,
        justify: 'start',
        wrap: false,
    }),
});
function componentsBySupport(mode) {
    return BUILT_IN_COMPONENT_IDS.filter((componentId) => COMPONENT_STYLING_SUPPORT_BY_COMPONENT[componentId] === mode);
}
function componentsByDriver(driver) {
    return BUILT_IN_COMPONENT_IDS.filter((componentId) => COMPONENT_STYLING_DRIVER_BY_COMPONENT[componentId] === driver);
}
export const RECIPE_BACKED_COMPONENTS = Object.freeze(componentsBySupport('recipe-backed'));
export const UTILITY_ONLY_COMPONENTS = Object.freeze(componentsBySupport('utility-only'));
export const UNSUPPORTED_COMPONENTS = Object.freeze(componentsBySupport('unsupported'));
export const RECIPE_DRIVEN_COMPONENTS = Object.freeze(componentsByDriver('recipe'));
export const UTILITY_DRIVEN_COMPONENTS = Object.freeze(componentsByDriver('utility'));
export const UNSTYLED_COMPONENTS = Object.freeze(componentsByDriver('none'));
export const SUPPORTED_COMPONENTS = Object.freeze([...RECIPE_BACKED_COMPONENTS, ...UTILITY_ONLY_COMPONENTS].sort(compareStrings));
export function getBuiltInComponentPropGuardrail(componentId, propName) {
    return BUILT_IN_COMPONENT_PROP_GUARDRAILS[componentId]?.[propName];
}
export function isBuiltInComponentPropResponsive(componentId, propName) {
    return BUILT_IN_COMPONENT_RESPONSIVE_PROPS[componentId]?.includes(propName) ?? false;
}
export function getBuiltInLayoutDefaultUtilityProps(componentId) {
    return BUILT_IN_LAYOUT_DEFAULT_UTILITY_PROPS[componentId];
}
//# sourceMappingURL=built-in-component-styling.js.map